import {
  View,
  Text,
  KeyboardAvoidingView,
  Platform,
  TouchableWithoutFeedback,
  Keyboard,
  TextInput,
} from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import {
  changeHeaderColor,
  hideBottomNavigation,
  showBackButton,
  showBackButtonWithFunction,
  showBottomNavigation,
} from "../../redux/header/headerAction";
import {
  danger,
  lightBlue,
  lighterBlue,
  orange,
  primary,
  textSecondary,
  white,
} from "../../colors";
import SelectChildrenMini from "../../components/custom/SelectChildrenMini";
import DoctorChatDetail from "../../components/consultation/DoctorChatDetail";
import ChatInput from "../../components/consultation/ChatInput";
import VoiceMessage from "../../components/consultation/chatMessage/VoiceMessage";
import TextMessage from "../../components/consultation/chatMessage/TextMessage";
import ImageMessage from "../../components/consultation/chatMessage/ImageMessage";
import { FlatList } from "react-native-gesture-handler";
import detailConsultationUser from "../../api/consultation/detailConsultationUser";
import getChatMessages from "../../api/consultation/getChatMessages";
import { io } from "socket.io-client";
import getToken from "../../api/token";
import getMessages from "../../api/support/getMessages";
import SupportChatInput from "../../components/consultation/SupportChatInput";
import MyText from "../../components/custom/MyText";
import { AntDesign } from "@expo/vector-icons";
import translate from "../../functions/translate";
import SupportTimeItem from "../../components/custom/SupportTimeItem";
import responseDayList from "../../api/consultation/responseDayList";
import MyButton from "../../components/custom/MyButton";
import setResponseDay from "../../api/consultation/setResponseDay";
import MyInputWithLabel from "../../components/custom/MyInputWithLabel";
import maxConsultation from "../../api/consultation/maxConsultation";
import setMaxConsultation from "../../api/consultation/setMaxConsultation";
import { FontAwesome } from "@expo/vector-icons";
import Fade from "../../components/animation/Fade";
import faqList from "../../api/consultation/faqList";
import deleteFaq from "../../api/consultation/deleteFaq";
import editFaq from "../../api/consultation/editFaq";
import addFaq from "../../api/consultation/addFaq";
import setHiMessage from "../../api/consultation/setHiMessage";
import Toast from "react-native-toast-message";
import setTimeNotif from "../../api/consultation/setTimeNotif";
import getTimeNotif from "../../api/consultation/getTimeNotif";

export default function Notifications({ route }) {
  const scrollViewRef = useRef(null);
  const [info, setInfo] = useState({
    notifTimeHour: "",
    notifTimeMinute: "",
  });

  useEffect(() => {
    getTimeNotif().then(({ data }) => {
      if (data.status === 200) {
        const time = data.data;
        if (time !== undefined && time !== null) {
          setInfo({
            notifTimeHour: time.split(":")[0],
            notifTimeMinute: time.split(":")[1],
          });
        }
      }
   
    });
    maxConsultation().then(({ data }) => {
      if (data.status === 200) {
        setInfo((prev) => {
          let newObj = prev;
          newObj["maxConsultation"] = data.data;
          return { ...newObj };
        });
      }
    });
  }, []);

  useEffect(() => {
    if (info.notifTimeMinute > 59) {
      setInfo((prev) => {
        return { ...prev, notifTimeMinute: "" };
      });
    }
    if (info.notifTimeHour > 23) {
      setInfo((prev) => {
        return { ...prev, notifTimeHour: "" };
      });
    }
  }, [info]);
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const isFocused = useIsFocused();

  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#fcfcfc"));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
    return () => {};
  }, [isFocused]);

  const saveChanges = () => {
    const standardTime = `${info.notifTimeHour.padStart(
      1,
      "0"
    )}:${info.notifTimeMinute.padStart(1, "0")}`;

    setTimeNotif(standardTime).then(({ data }) => {
      if (data.status === 200) {
        Toast.show({
          type: "success",
          text1: "تغییرات با موفقیت انجام شد",
        });
      }
    });
  };

  return (
    <View>
      <KeyboardAwareScrollView
        ref={scrollViewRef}
        enableOnAndroid
        extraHeight={100}
      >
        <View style={{}}>
          <View
            style={{
              backgroundColor: "#fff",
              width: "100%",
              alignItems: "center",
              flex: 1,
              paddingBottom: Platform.OS !== "web" ? 30 : 0,
            }}
          >
            <View
              style={{
                width: "95%",
                backgroundColor: "#eeeeee",
                padding: 10,
                marginVertical: 10,
                borderRadius: 5,
              }}
            >
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <View>
                  <FontAwesome name="bell-o" size={30} color="#33a075" />
                </View>
                <MyText style={{ marginHorizontal: 10, fontSize: 18 }}>
                  اعلانات برنامه
                </MyText>
              </View>
            </View>
            <View style={{ flex: 1, width: "100%", alignItems: "center" }}>
              <View
                style={{
                  width: "95%",
                  padding: 10,
                  borderRadius: 10,
                  backgroundColor: "#fafafa",
                  borderWidth: 1,
                  borderColor: "#eeeeee",
                }}
              >
                <View>
                  <MyText style={{ fontSize: 16 }}>
                    زمان دریافت اعلانات چت
                  </MyText>
                  <MyText style={{ fontSize: 11 }}>
                    پس از این که کاربر چت را شروع کرد این پیام به صورت خودکار
                    برای او ارسال میشود
                  </MyText>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    marginVertical: 20,
                    alignItems: "center",
                  }}
                >
                  <View
                    style={{
                      width: "50%",

                      alignItems: "center",
                    }}
                  >
                    <MyText>ساعت</MyText>
                    <MyInputWithLabel
                      keyboardType="number-pad"
                      name="notifTimeHour"
                      setInput={setInfo}
                      value={info.notifTimeHour}
                    />
                  </View>
                  <View
                    style={{
                      width: "50%",

                      alignItems: "center",
                    }}
                  >
                    <MyText>دقیقه</MyText>
                    <MyInputWithLabel
                      value={info.notifTimeMinute}
                      name="notifTimeMinute"
                      keyboardType="number-pad"
                      maxValue={59}
                      setInput={setInfo}
                    />
                  </View>
                </View>
                <View
                  style={{
                    flex: 1,
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  <MyButton
                    style={{}}
                    text="ذخیره تغییرات"
                    onPress={saveChanges}
                  />
                </View>
              </View>
            </View>
          </View>
        </View>
        <View style={{ height: 100 }}></View>
      </KeyboardAwareScrollView>
    </View>
  );
}
